import { render, staticRenderFns } from "./IntellectualPropertyPolicy.vue?vue&type=template&id=41f2f3fa&scoped=true"
import script from "./IntellectualPropertyPolicy.vue?vue&type=script&lang=js"
export * from "./IntellectualPropertyPolicy.vue?vue&type=script&lang=js"
import style0 from "./IntellectualPropertyPolicy.vue?vue&type=style&index=0&id=41f2f3fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f2f3fa",
  null
  
)

export default component.exports